import React from 'react'
import Newsletter from './Newsletter/Newsletter'
import "./footer.css"
import logo from "./images/logo new.png"
import {AiOutlineInstagram, AiFillLinkedin, AiOutlineTwitter} from 'react-icons/ai'
import {BiLogoFacebookCircle} from "react-icons/bi"
import {BsPinterest} from "react-icons/bs"

function Footer() {
  return (
    <>
      <div>
        <Newsletter />
      </div>
      <div className="footer-container">
        <div className="footer-top-content">
          <div className="ft-1 ft-element">
            <div className="ft-logo">
              <img src={logo} alt="" className="ft-img" />
            </div>
            <p className='ft-para'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Eligendi quasi perferendis ratione perspiciatis accusantium.</p>
          </div>
          <div className="ft-2 ft-element">
            <ul className="ft-list">
              <li>Home</li>
              <li>About Us</li>
              <li>Portfolio</li>
              <li>Services</li>
              <li>Contact</li>
            </ul>
          </div>
          <div className="ft-3 ft-element">
            <ul className="ft-list">
              <li>Clients</li>
              <li>Team</li>
              <li>Career</li>
              <li>Testimonials</li>
              <li>Journal</li>
            </ul>
          </div> 
          <div className="ft-4 ft-element">
            <ul className="ft-list">
              <li>Privacy Policy</li>
              <li>Terms & Conditions</li>
              <li>Partners</li>
            </ul>
          </div>
          <div className="ft-5 ft-element">
            <div className="ft-icons">
            <a href="https://www.instagram.com/_tanzeel_kh/"><AiOutlineInstagram /></a>
            <a href="https://twitter.com/tanzeeltwt"><AiOutlineTwitter /></a>
            <a href="https://www.linkedin.com/in/ahamad-tanzeel-khan-1b1760252/"><AiFillLinkedin /></a>
            <a href="https://www.instagram.com/_tanzeel_kh/"><BiLogoFacebookCircle /></a>
            <a href="https://www.linkedin.com/in/ahamad-tanzeel-khan-1b1760252/"><BsPinterest /></a>
            </div>
            <div className="ft-btn-container">
              <button className="ft-btn">Contact Us</button>
            </div>
          </div>
        </div>
        <div className="footer-bottom-content">
          <div className="ft-copyright">
            <p>© 2022-2023 Ahamad Tanzeel Khan All Rights Reserved.</p>
          </div>
        </div>
      </div>
    </>
  )
}

export default Footer
